import { createFileRoute } from '@tanstack/react-router';

import { CloseoutPage } from '@/features/owner/closeout-page';

export const Route = createFileRoute('/_app/projects/$projectId/closeout/overview')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <CloseoutPage projectId={projectId} />;
}
